import { Typography } from '@mui/material';

import logo from '../../../../public/logo.svg';

import { EmptyPageContentStyled, EmptyPageRootStyled } from './empty-page.styled';

export const EmptyPage = () => {
  return (
    <EmptyPageRootStyled>
      <EmptyPageContentStyled>
        <img src={logo} alt="Logo" />
        <Typography variant="h5" fontWeight={600}>
          Сторінка знаходиться в розробці
        </Typography>
      </EmptyPageContentStyled>
    </EmptyPageRootStyled>
  );
};
